import { render, staticRenderFns } from "./FoodServiceTabSelect.vue?vue&type=template&id=074daeea&scoped=true"
import script from "./FoodServiceTabSelect.vue?vue&type=script&lang=js"
export * from "./FoodServiceTabSelect.vue?vue&type=script&lang=js"
import style0 from "./FoodServiceTabSelect.vue?vue&type=style&index=0&id=074daeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074daeea",
  null
  
)

export default component.exports